<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Route List</h4>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                  color="primary"
                  class="float-left mb-2"
                  @click="routeCreate"
              >Create</CButton
              >
            </CCol>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                      class="float-left ml-2 mr-3"
                      placeholder="Search By Asal/Tujuan"
                      v-model="request.s"
                      @input="onSearch()"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="20"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          >
            <template #route_origin="data">
              <td>{{ toTitleCaseLocation(data.item.origin_route.route_code) }}</td>
            </template>
            <template #route_destination="data">
              <td>{{ toTitleCaseLocation(data.item.destination_route.route_code) }}</td>
            </template>
            <template #route_status="data">
              <td class="capitalize">
                <div :class="data.item.status.toLowerCase() === 'active' ? 'chipGreen' : 'chipGray'">{{ data.item.status.toLowerCase() }}</div>
              </td>
            </template>
            <template #route_id="data">
              <td>
                <div class="button-table">
                  <CButton
                      color="primary"
                      class="mb-0 mr-0"
                      @click="rowClicked(data.item.id)"
                  >Edit</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
                class="pagination-btn-refresh"
                @click="getRouteList('REFRESH')"
            >
              Refresh
            </div>
            <div
                class="pagination-btn-back"
                @click="getRouteList('BACK')"
            >
              back
            </div>
            <div class="pagination-page-title">{{ request.page }}</div>
            <div
                class="pagination-btn-next"
                @click="getRouteList('NEXT')"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import jwt from "jsonwebtoken";
import RouteUseCase from "./app/usecase";

export default {
  name: "Routes",
  data() {
    return {
      items: [],
      fields: [
        { key: "id", label: "ID" },
        { key: "route_origin", label: "Asal" },
        { key: "route_destination", label: "Tujuan" },
        { key: "route_status", label: "Status" },
        { key: "route_id", label: "Action" },
      ],
      token: "Bearer " + localStorage.getItem("token"),
      request: {
        page: 1,
        per_page: 20,
      },
      debounce: {
        timeout: 0,
        duration: 500,
      },
      searchTimeout: null,
    };
  },
  mounted() {
    this.authentication();
    this.getRouteList();
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    onSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(this.searchRouteList, this.debounce.duration);
    },
    async searchRouteList() {
      try {
        await this.getRouteList()
        this.request.page = 1
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err
        })
      }
    },
    async getRouteList(action) {
      try {
        this.validatePagination(action);
        const queries = Object.keys(this.request).map((key) => key + "=" + this.request[key]).join("&");
        const { data, err } = await RouteUseCase.getAll(queries);
        if (err || data.length == 0) {
          this.validateNextPagination(action);
          this.err = err;
        } else {
          if (data) {
            window.scrollTo(0, 0);
            this.items = data;
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    validatePagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page + 1;
      } else if (action === "BACK") {
        if (this.request.page > 1) {
          this.request.page = this.request.page - 1;
        }
      } else if (action === "REFRESH") {
        this.request.page = 1;
      } else {
        this.request.page = 1;
      }
    },
    validateNextPagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page - 1;
      } else {
        this.items = [];
      }
    },
    rowClicked(item) {
      this.$router.push({ path: `/management/routes/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    routeCreate() {
      this.$router.push({ path: `/management/routes/create` });
    },
    toTitleCaseLocation(str) {
      if (!str) return "";

      // split main text and code (CGK) if exists
      const match = str.match(/^(.*?)(\s*\(.*?\))?$/);
      const text = match[1].toLowerCase(); // main text lowercased
      const code = match[2] || "";         // preserve (CGK)

      // convert EACH word to Title Case
      const title = text.replace(/\w\S*/g, (w) =>
        w.charAt(0).toUpperCase() + w.slice(1)
      );

      return title + code;
    }
  },
};
</script>

<style scoped>
@import "./Routes.css";
</style>
